export const FETCH_DIAGRAMS = 'diagrams/FETCH_DIAGRAMS';
export const FETCH_PROJECT_DIAGRAMS = 'diagrams/FETCH_PROJECT_DIAGRAMS';
